import Modal from 'react-modal';
import { useState } from 'react';
import * as d3 from "d3";

import exportSVG from "../noncomponents/exportSVG"
import eye from '../assets/data/digitoegankelijkheid/eye.svg'

import table from '../assets/data/digitoegankelijkheid/digitoegankelijk_tabel.htm'

function BurgerMenu() {

  let subtitle;
  const [modalIsOpen, setIsOpen] = useState(false);

  const modalStyle = {
    content: {
      top: '100px',
      left: '100px',
      right: 'auto',
      bottom: 'auto',
      width:'400px',
      height:'100px'
      // marginRight: '-50%',
      // transform: 'translate(-50%, -50%)',
    },
  };

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#726f6d';
  }

  function hover(){
    d3.select('.accessibility_text')
      .style('visibility', 'visible');
  }

  function mouseOut(){
    d3.select('.accessibility_text')
      .style('visibility', 'hidden');
  }

  return (
    <div className="digitoegankelijkheid">
      <input
        type='image'
        tabIndex='0'
        onClick={() => setIsOpen(true)}
        onMouseOver={() => hover()}
        onMouseOut={() => mouseOut()}
        style={{ cursor:'pointer' }}
        className='accessibility_image'
        src={eye}
        alt='Opties voor toegankelijkheid openen'
      />
      <p className='accessibility_text'>Digitoegankelijkheid</p>
      {/* <p className='sr-only'>Klik op de knop "Opties voor toegankelijkheid openen" om een toegankelijk alternatief te downloaden</p> */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        onAfterOpen={afterOpenModal}
        style={modalStyle}
        contentLabel="Dit scherm laat de verschillende toegankelijkheidsopties zien"
      >

        {/* <h2 ref={(_subtitle) => (subtitle = _subtitle)}>Droogteketen tutorial</h2> */}
        <div style={{ width:'100%' }} >
          <a href={table} target="_blank">
            Bekijk toegankelijk alternatief
          </a>
          <br/><br/>
          <a download >
            [In ontwikkeling] Download digitoegankelijkheids verklaring (pdf)
          </a>
        </div>
        <button onClick={() => setIsOpen(false)} style={{ position:'absolute', right:'4px', top:'4px' }}>
          Sluiten
        </button>

      </Modal>

    </div>
  );
}

export default BurgerMenu;
